
































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ModalHeader from "@/components/ModalHeader.vue";
import { GapPatientFilter } from "@/store/modules/types";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { BFormInput } from "bootstrap-vue";

@Component({
  components: {
    ModalHeader,
    BFormInput,
  },
  filters: {
    phone: function (phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    },
  },
})
export default class PatientSearch extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly phone!: string;
  filter: GapPatientFilter = {
    id: "",
    firstName: "",
    lastName: "",
    insurerMemberId: "",
    EMR_ID: "",
    birthdateFrom: null,
    birthdateTo: null,
    city: "",
    gender: "",
    phone: "",
    insurerList: [],
    ipaList: []
  };
  patients: Array<any> = [];
  async getPatients() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.patients = await this.$store.dispatch(
        "gaps/getPatients",
        this.filter
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  select(patient, phoneType, phone) {
    if (!phoneType && !phone) {
      phoneType = patient.mobilePhone
        ? "M"
        : patient.homePhone
        ? "H"
        : patient.otherPhone
        ? "O"
        : patient.otherPhone2
        ? "O"
        : "";
      phone =
        patient.mobilePhone ||
        patient.homePhone ||
        patient.otherPhone ||
        patient.otherPhone2 ||
        "";
    }
    this.$emit("selected", patient, phoneType, phone);
    this.$modal.hide("patient-search");
  }
  mounted() {
    if (this.phone) this.filter.phone = this.phone;
    this.getPatients();
  }
}
